export const ProgressDotStyle: React.CSSProperties = {
    backgroundColor: 'red',
    borderRadius: '25px',
    width: '10px',
    height: '5px',
    margin: 'auto 4px',
    zIndex: '2',
};

export const CurrentDotStyle: React.CSSProperties = {
    ...ProgressDotStyle,
    width: '25px',
};
